import script from "./technologyPop.vue?vue&type=script&setup=true&lang=js"
export * from "./technologyPop.vue?vue&type=script&setup=true&lang=js"

import "./technologyPop.vue?vue&type=style&index=0&id=7de790b8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7de790b8"]])

export default __exports__